import {CLIENT_CALL_TYPE_MAP} from '@pexip/infinity';
import type {ClientCallType} from '@pexip/infinity/clientCallType';

export const getClientCallType = (
    input: string | undefined,
): ClientCallType | undefined =>
    CLIENT_CALL_TYPE_MAP.get(String(input).toLowerCase());
